<template>
  <div class="h-full w-full">
    <div class="mb-10px">
      <el-input
        class="mr-10px !w-250px"
        clearable
        v-model="Keyword"
        placeholder="计划名称"
      ></el-input>
      <el-button class="mr-10px" type="primary" @click="searchList"> 搜索</el-button>
      <el-button class="mr-10px" type="primary" @click="resetSearch"> 重置</el-button>
      <el-button class="mr-10px" type="primary" @click="operate()"> 新增</el-button>

      <el-button type="danger" @click="deleteAny"> 删除</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      height="calc(100% - 70px)"
      stripe
      v-loading="loading"
      ref="tableRef"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="index" label="序号" :width="60"></el-table-column>
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :fixed="item.fixed || false"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" align="left" width="200px" fixed="right">
        <template slot-scope="scope">
          <div>
            <el-button class="mr-10px" size="mini" @click="operate(scope.row, 'view')"
              >查看</el-button
            >
            <el-button class="mr-10px" size="mini" @click="operate(scope.row, 'edit')"
              >编辑</el-button
            >
            <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
          </div>
        </template></el-table-column
      >
    </el-table>
    <div class="text-right mt-10px">
      <el-pagination
        background
        @size-change="getList()"
        @current-change="getList()"
        :current-page.sync="page.no"
        :page-size.sync="page.size"
        :page-sizes="[10, 15, 20, 30, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  components: {},
  data() {
    return {
      Keyword: '',
      columns: [
        { prop: 'name', label: '项目计划名称', width: 300 },
        { prop: 'startTime', label: '计划开始时间' },
        { prop: 'endTime', label: '计划结束时间' },
        { prop: 'period', label: '工期' },
      ],
      loading: true,
      tableData: [],
      checkList: [],
      page: {
        no: 1,
        size: 20,
        total: 0,
      },
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    async getList() {
      this.loading = true

      this.loading = false
    },
    resetSearch() {
      this.Keyword = ''
      this.tableData = []
      this.page.no = 1
      this.getList()
    },
    searchList() {
      this.page.no = 1
      this.tableData = []
      this.getList()
    },

    operate(row, mode) {
      this.$router.push({
        path: `${this.basePath}/construction-schedule-management/project-schedule-detail`,
        query: {
          mode,
          id: row?.id,
        },
      })
    },
    async deleteItem(row) {
      this.$confirm(this.$t('是否确定删除?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(async () => {})
    },

    edit(row) {},
    closeDialog() {},

    handleSelectionChange(val) {
      this.checkList = val.map((o) => {
        return o.id
      })
    },
    // eslint-disable-next-line consistent-return
    deleteAny() {
      if (this.checkList.length === 0) return this.$message.warning('至少选择一个任务！')
      this.$confirm('是否删除选中计划！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {})
    },
  },
  mounted() {
    this.getList()
  },
  destroyed() {},
}
</script>

<style>
</style>
